import LocationWrapper from "./LocationList/LocationWrapper";
export default LocationWrapper;
